"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
;
//# sourceMappingURL=IRoutesManager.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/core/dist/services/IRoutesManager.js
// module id = 2027
// module chunks = 0